import React from 'react'
import moment from 'moment'
import { Input, Button } from 'semantic-ui-react'

export default props => {
  const { start, end, loading, onButtonClick, onStartChange, onEndChange, style } = props

  return (
    <div style={style}>
      <div className="capitalize" style={{ display: 'inline-block', marginRight: 10 }}>
        Request Date: From
      </div>
      <Input
        type="date"
        name="from"
        value={start}
        onChange={e =>
          onStartChange(
            Number(
              moment(e.target.value)
                .startOf('day')
                .format('x')
            )
          )
        }
      />

      <div className="capitalize" style={{ display: 'inline-block', marginLeft: 10, marginRight: 10 }}>
        To
      </div>
      <Input
        type="date"
        name="to"
        value={end}
        onChange={e =>
          onEndChange(
            Number(
              moment(e.target.value)
                .endOf('day')
                .format('x')
            )
          )
        }
      />

      <Button loading={loading} disabled={loading} onClick={onButtonClick} style={{ marginLeft: 10 }}>
        Search
      </Button>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/containers/cashOuts/components/DateRangeSearch.js